//Iterate through Nested JavaScript Objects
import { Base64 } from "js-base64";
import { saveAs } from "file-saver";
import d from "downloadjs"
export const iterate = (obj) => {
  Object.keys(obj).forEach((key) => {
    console.log(`key: ${key}, value: ${obj[key]}`);

    if (typeof obj[key] === "object" && obj[key] !== null) {
      iterate(obj[key]);
      if (typeof obj[key] === "object" && obj[key] !== null) {
        iterate(obj[key]);
      }
    }
  });
};
export const getText = (file) => {
  console.log(file);
  const text = Base64.decode(file.payload.base64File);
  let blob = new Blob([text], {
    type: "text/plain",
  });
  saveAs(blob, "translated-file.po");
};

const Tag = {
  Type: "bpt" | "ept" | "ph" | "not-found",
  Value: String,
  Start: Number,
  End: Number,
}

export function findTag(sample) {
  let tagTypes = ["bpt",  "ept", "ph"]
  let tagFound = false;
  let tagType = " ";
  let id = "";
  let tagStart = 0;
  let tagEnd = 0;
  
  //2. Main loop, in the search of '<' tag
  //   (-15 is because it is the smallest possible amount of chars
  //    required to write the smallest tag (without first '<' char)) 
  //    <ph id="1"></ph> )
  for(let i = 0; i < sample.length - 15; i++){

      if(sample[i] === '<'){

          //2.1 beggining char was found. Now code has to check wether it 
          //begins the tag or is it just random element
          let firstLetter = sample[i + 1];
          let secoundLetter = sample[i + 2];
          let thirdLetter = sample[i + 3];

          tagStart = i;
          tagEnd = i;

          if(firstLetter === 'p' && secoundLetter === 'h' && thirdLetter === ' '){
              //this is a ph tag
              tagType = "ph";
          }
          else{
              if(secoundLetter === 'p' && thirdLetter === 't'){
                  //?pt, so if first letter is 'b' or 'e' and fourth is ' ',
                  //then it is either bpt or ept tag
                  if(sample[i + 4] === ' '){
                      //fourth letter is ' ', so all that's left is checking
                      //first letter
                      if(firstLetter === 'b'){
                          //it's bpt tag
                          tagType = "bpt";
                      }
                      else if(firstLetter === 'e'){
                          tagType = "ept";
                      }
                      else continue;
                  }
                  else continue;
              }
              else continue;
          }
          //2.2 Algorithm has confirmation, that there is a tag and
          //it knows it's type. Now there is a search for 'id'
          i = i + 3;
          for(;i < sample.length; i++){
              
              if(sample[i] === 'i'){
                  
                  //2.2.1 In the tag, there is a letter 'i' found.
                  //Algorithm checks is it [whitespace]id="?????" attribute
                  if(sample[i - 1] === ' ' && sample[i + 1] === 'd' && sample[i + 2] === '=' && sample[i + 3] === '"'){
                      
                      //2.2.2 'id' attribute identified. Extract it's value
                      let start = i + 4;
                      let end = start + 1;
                      
                      i = i + 5;
                      //2.2.2.1 Search for closing '"' of id attribute
                      for(; i < sample.length; i++){
                          if(sample[i] !== '"'){
                              end++;
                          }
                          else break;
                      }
                      //2.2.2.2 closing attribute was found. Value of id
                      //between start and end indexes
                      id = sample.substring(start,end);
                      break;
                  }
                  else continue;
              }
              else continue;
          }

          //2.3 Algorithm found value of id. Now it looks for end </[type]>
          //    (-5 is because </ph>)
          for(;i < sample.length - 4; i++){
              if(sample[i] === '<'){
                  if(sample[i + 1] === '/'){
                      let fl = sample[i + 2];
                      if(fl === 'p' && tagType === "ph"){
                          if(sample[i + 3] === 'h' && sample[i + 4] === '>'){
                              tagEnd = i + 4;
                              tagFound = true;
                              break;
                          }
                          else continue;
                      }
                      else if(sample[i + 3] === 'p' && sample[i + 4] === 't' && sample[i + 5] === '>'){
                          if((fl === 'b' && tagType === "bpt") || (fl === 'e' && tagType === "ept")){
                              tagEnd = i + 5;
                              tagFound = true;
                              break;
                          }
                          else continue;
                      }
                  }
              }
          }

          if(tagFound){
              break;
          }
      }
      else continue;
  }


  return tagFound ? Tag = {
      Type: tagType,
      Value: id,
      Start: tagStart,
      End: tagEnd
  } : null;
}

export function GenerateHtmlVersionOfTag(tag, id){
  return `<img class='${tag} ${tag}${id}' alt='${id}' src='data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=='/>`;
}

export function TagToHtml(foundTag) {
    
  let tag = "";
  switch(foundTag.Type){
      case "bpt":
          tag = GenerateHtmlVersionOfTag("bpt", foundTag?.Value ?? " ");
          break;
      case "ept":
          tag = GenerateHtmlVersionOfTag("ept", foundTag?.Value ?? " ");
          break;
      case "ph":
          tag = GenerateHtmlVersionOfTag("ph", foundTag?.Value ?? " ");
          break;
  }
  return tag;
}

{/* <div className="col-6 col-md-2">
               
               <div className="form-check">
                 <input
                   className="form-check-input"
                   type="radio"
                   id="translate-all"
                   name="drone"
                   value="options"
                   checked
                   onChange={translationOptionsHandler}
                 ></input>
                 <label className="form-check-label" htmlFor="translate-all">
                   Translate all
                 </label>
               </div>
             </div>
             <div className="col-6 col-md-3">
               <div className="form-check">
                 <input
                   className="form-check-input"
                   type="radio"
                   id="translate-only"
                   name="drone"
                   value="options"
                   onChange={translationOptionsHandler}
                 ></input>
                 <label className="form-check-label" htmlFor="translate-only">
                   Translate only elements:
                 </label>
               </div>
             </div>
             <div class="col">
               <div className="form-check">
                 <input
                   className="form-check-input"
                   type="radio"
                   id="paragraph"
                   name="drone"
                   value="options"
                   onChange={translationOptionsHandler}
                 ></input>
                 <label className="form-check-label" htmlFor="form-check-input">
                   Do not translate elements:
                 </label>
               </div>
             </div>
           </div>
           Content included
           <div class="row">
             <div class="col-6 col-md-2">
               <div className="form-check">
                 <input
                   className="form-check-input"
                   type="radio"
                   id="paragraph"
                   name="drone"
                   value="paragraph"
                 ></input>
                 <label className="form-check-label" htmlFor="paragraph ">
                   Plain text
                 </label>
               </div>
             </div>
             <div class="col-6 col-md-3">
               <div className="form-check">
                 <input
                   className="form-check-input"
                   type="radio"
                   id="paragraph"
                   name="drone"
                   value="paragraph"
                   checked
                 ></input>
                 <label className="form-check-label" htmlFor="paragraph ">
                   HTML
                 </label>
               </div>
             </div>
             <div class="col">
               <div className="form-check">
                 <input
                   className="form-check-input"
                   type="radio"
                   id="paragraph"
                   name="drone"
                   value="paragraph"
                 ></input>
                 <label className="form-check-label" htmlFor="paragraph ">
                   Markdown
                 </label>
               </div>
             </div> */}